import type { ComponentProps } from "react";
import { cn } from "@/shared/utils/cn";

export interface CardProps extends ComponentProps<"div"> {
  tone?: "default" | "matcha" | "ai" | "cream";
}

export function Card({ tone = "default", className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        "min-w-0 rounded-[20px] border border-border p-4 text-card-foreground sm:p-5",
        tone === "default" && "bg-card",
        tone === "matcha" && "bg-matcha",
        tone === "ai" && "bg-lilac text-lilac-foreground",
        tone === "cream" && "bg-cream",
        className,
      )}
      {...props}
    />
  );
}
